export const EDITOR_MANAGING_Q_INDICATORS_OPTIONS = [
  "number",
  "name",
  "LastPeriodIndicatorId",
  "ValueIndicatorId",
  "GroupIndicatorId",
  "AverageIndicatorId",
  "DifferenceIndicatorId",
  "GroupAverageIndicatorId",
  "updatedAt",
];

export const EDITOR_MANAGING_Q_INDICATORS_PERIOD_OPTIONS = [
  "LastPeriodIndicatorId",
  "ValueIndicatorId",
  "GroupIndicatorId",
  "AverageIndicatorId",
  "DifferenceIndicatorId",
  "GroupAverageIndicatorId",
];
